import React from 'react';

import styles from './TinybopSchoolsMaterials.scss';

export default () => (
  <div className="TinybopSchoolsMaterials">
    <a
      className="TinybopSchoolsMaterials__handbook"
      href="https://schools-cdn.tinybop.com/assets/handbooks/en/tinybop-earth-handbook.pdf"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        className="TinybopSchoolsMaterials__handbook-icon"
        src="https://schools.tinybop.com/assets/components/GameHandbook/handbook-thumb-earth.png"
        alt="Mammals Handbook Cover"
      />
      <div className="TinybopSchoolsMaterials__handbook-text">
        <p>
          <strong>THE EARTH HANDBOOK</strong>
        </p>
        <p>
          Look to the handbook for supplementary information, interaction hints,
          questions, and answers.
        </p>
        <p className="TinybopSchoolsMaterials__link">VIEW</p>
      </div>
    </a>
  </div>
);
